var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7843 12.7992L12.875 11.89C13.1548 11.4703 13.2947 10.9807 13.2947 10.4911C13.2947 8.95245 12.0357 7.69351 10.497 7.69351C8.95834 7.69351 7.6994 8.95245 7.6994 10.4911C7.6994 12.0298 8.95834 13.2888 10.497 13.2888C10.9866 13.2888 11.4762 13.1489 11.8959 12.8691L12.8051 13.7784C12.945 13.9183 13.3646 14.198 13.7843 13.7784C14.064 13.4986 14.064 13.079 13.7843 12.7992ZM10.497 11.89C9.72769 11.89 9.09822 11.2605 9.09822 10.4911C9.09822 9.7218 9.72769 9.09233 10.497 9.09233C11.2664 9.09233 11.8959 9.7218 11.8959 10.4911C11.8959 11.2605 11.2664 11.89 10.497 11.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4973 0H0.705513C0.285868 0 0.00610352 0.279764 0.00610352 0.69941V13.2888C0.00610352 13.7084 0.285868 13.9882 0.705513 13.9882H8.1892C7.07014 13.2188 6.30079 11.9599 6.30079 10.4911C6.30079 8.18309 8.1892 6.29469 10.4973 6.29469C10.7071 6.29469 10.9868 6.29469 11.1967 6.36463V0.69941C11.1967 0.279764 10.9169 0 10.4973 0ZM5.60138 5.59528H2.10433C1.68469 5.59528 1.40492 5.24557 1.40492 4.89587C1.40492 4.47622 1.68469 4.19646 2.10433 4.19646H5.60138C6.02103 4.19646 6.30079 4.47622 6.30079 4.89587C6.30079 5.24557 6.02103 5.59528 5.60138 5.59528ZM9.09843 2.79764H2.10433C1.68469 2.79764 1.40492 2.44793 1.40492 2.09823C1.40492 1.67858 1.68469 1.39882 2.10433 1.39882H9.09843C9.51808 1.39882 9.79784 1.67858 9.79784 2.09823C9.79784 2.44793 9.51808 2.79764 9.09843 2.79764Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearch);
export default __webpack_public_path__ + "static/media/Research.c6a4d184.svg";
export { ForwardRef as ReactComponent };